var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModule({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: "100%",
      height: "auto"
    },
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 19V21V19ZM16 19V21V19ZM1 13V7C1 4.172 1 2.757 1.93 1.879C2.86 1.001 4.358 1 7.353 1H12.647C15.642 1 17.139 1 18.07 1.879C19 2.757 19 4.172 19 7V13C19 15.828 19 17.243 18.07 18.121C17.14 18.999 15.642 19 12.647 19H7.353C4.358 19 2.861 19 1.93 18.121C1 17.243 1 15.828 1 13ZM10 19V1V19ZM1 13H10H1ZM1 7H10H1ZM13 10.5V9.5V10.5Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19V21M16 19V21M1 13V7M1 13C1 15.828 1 17.243 1.93 18.121C2.861 19 4.358 19 7.353 19H12.647C15.642 19 17.14 18.999 18.07 18.121C19 17.243 19 15.828 19 13V7C19 4.172 19 2.757 18.07 1.879C17.139 1 15.642 1 12.647 1H7.353C4.358 1 2.86 1.001 1.93 1.879C1 2.757 1 4.172 1 7M1 13H10M1 7H10M10 19V1M13 10.5V9.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule);
export default __webpack_public_path__ + "static/media/module.3b58f99ac2a004bfba7f1c15c0f46a7b.svg";
export { ForwardRef as ReactComponent };